import { connect, useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@rmwc/checkbox";
import Accordion from "react-bootstrap/Accordion";
import EditPriceItem from "../../../EditPriceItem/EditPriceItem";
import CurrencyFormat from "react-currency-format";
import { Button, Card, OverlayTrigger, Popover } from "react-bootstrap";
import { sidingNameUpdateForWallTexture } from "../../../../redux/reducers/utils.js";
import { handleAccordion, roofColorChange, updateWainscot } from "../../../../action/index.js";
import { useColorPicker } from "../Common/useColorPicker.js";
import ColorGroup from "../Common/ColorGroup.js";
const MATCH_KEY = "wainscot";
const WainscotColor = () => {
	const { const_var, params } = useSelector((state) => state.reducer);
	const dispatch = useDispatch();
	const callPricingAPI = (force) => {
		// const buildingType = const_var?.post_data.building?.building_type;
		// const sheetName = const_var.post_data.building.wainscot?.sheet_name;
		// const checkDollarExist = const_var.c_m_a?.[buildingType]?.wainscot_details?.find((wain) => wain?.name === sheetName);
		// if (!checkDollarExist || checkDollarExist.price_type !== "$") return;
		// const shouldCall = force || const_var.wainscotApiCall !== "" || sheetName !== "metal";
		// if (!shouldCall) return;
		// if (checkDollarExist?.name !== const_var?.wainscotApiCall) {
		// dispatch(getPricingDataForWainscot());
		// }
	};
	let free = false;
	let wallOrientation = params.wallOrientation ?? (params.p_v_w ? "vertical" : "horizontal");
	if (!params.wallOrientation) {
		const filterWainscot = const_var?.c_m_a?.[params.p_b_t]?.wainscot_details?.filter((w) => sidingNameUpdateForWallTexture(w.name) === sidingNameUpdateForWallTexture(const_var.selSidingObj.name));
		const orientations = filterWainscot?.[0]?.panel_orientation;
		if (orientations?.length === 1) {
			wallOrientation = orientations[0];
		} else {
			wallOrientation = params.p_v_w ? "vertical" : "horizontal";
		}
	}
	const selectedSiding = const_var.selSidingOption.toLowerCase();
	if (selectedSiding.includes("horizontal")) wallOrientation = "horizontal";
	if (selectedSiding.includes("vertical")) wallOrientation = "vertical";
	const filterdWainscotMaterial = const_var.color.filter(
		(color) =>
			color.color_category_mapping.material_category?.some((siding) => selectedSiding.toLowerCase().includes(siding.toLowerCase())) &&
			color.applicable_on?.some((applicable) => applicable.toLowerCase().includes(MATCH_KEY))
	);
	const toCategoryKey = (category) => category.toLowerCase().replace(/\s+/g, "_");
	const formatCategoryLabel = (key) =>
		key
			.split("_")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");

	const wainscotColors = {};
	filterdWainscotMaterial.forEach((color) => {
		const categories = color.color_category_mapping?.material_category;
		[...new Set(categories)].forEach((category) => {
			const key = toCategoryKey(category);
			if (!wainscotColors[key]) wainscotColors[key] = [];
			if (!wainscotColors[key].find((c) => c.id === color.id)) {
				wainscotColors[key].push(color);
			}
		});
	});
	let selectedTab = params.wainscotTexture;
	if (params.wainscotTexture.includes("stackstone")) selectedTab = "stackstone";
	if (params.wainscotTexture == "none" || params.wainscotTexture == "vertical") selectedTab = "metal";
	return (
		<>
			<div className={const_var.showWainscotJSX == true ? "wainscot" : "wainscot disabled"}>
				<div class="tab-pane-header">
					<div className="tab-panel-action">
						<div className="check-group">
							<Checkbox
								className="secondary"
								ripple="RipplePropF"
								label="Add Wainscot"
								checked={params.p_w_c_n}
								onChange={(e) => {
									dispatch(updateWainscot());
									callPricingAPI(true);
								}}
							/>
							{
							const_var.post_data.building != undefined && const_var.loginSession == true ? (
								<div className="price-box">
									<EditPriceItem is_disabled="false" jsonObjValue={const_var.post_data.building?.wainscot_price ?? 0} jsonObjKey="wainscot_price" />
								</div>
							) :
							 (
								<div className="price-box-type-2">
									{const_var.hide_price_calculation != 1 && const_var.loginSession == false && const_var?.post_data?.building?.wainscot_price !== 0 && (
										<CurrencyFormat value={const_var.post_data.building.wainscot_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
									)}
								</div>
							)}
						</div>
					</div>
				</div>
				<div class={`tab-pane-header ${params.p_w_c_n == true ? "" : "disable-field"}`}>
					<div class="tab-pane-label mr-1">
						Selected Color{free ? "(Free)" : ""} : &nbsp;
						<strong>{params.p_w_c_c_name}</strong>
					</div>
					{
					const_var.post_data.building != undefined && const_var.loginSession == true ? (
						<div className={free ? "price-box disabled" : "price-box"}>
							<EditPriceItem jsonObjValue={const_var.post_data.building?.wainscot_color_price ?? 0} jsonObjKey="wainscot_color_price" />
						</div>
					) : 
					(
						<div className="price-box-type-2">
							{const_var.hide_price_calculation != 1 && const_var.loginSession == false && const_var.post_data.building !== undefined && const_var.post_data.building.wainscot_color_price !== 0 && (
								<CurrencyFormat value={const_var.post_data.building.wainscot_color_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
							)}
						</div>
					)}
				</div>

				<div className={params.p_w_c_n == true ? " " : "color-group disable-field"}>
					<Accordion className="w-full accordion-type-2 color-accordion" defaultActiveKey={selectedTab}>
						{Object.keys(wainscotColors).map((val) => {
							let className = "";
							return (
								<>
									<Card className={`${val} ${val == selectedTab ? "active" : ""}`}>
										<Card.Header>
											<Accordion.Toggle as={Button} variant="link" eventKey={val} onClick={(e) => dispatch(handleAccordion(e))}>
												{`${formatCategoryLabel(val)}`}
												<i className="icon icon-arrow-down-ico"></i>
											</Accordion.Toggle>
										</Card.Header>
										<ColorComponent
											keyName={val}
											wainsCoatColors={wainscotColors?.[val]}
											onHandle={(color) => {
												dispatch(roofColorChange("Wainscot", color));
												callPricingAPI();
											}}
										/>
									</Card>
								</>
							);
						})}
					</Accordion>
				</div>
			</div>
		</>
	);
};
export default WainscotColor;

const ColorComponent = ({ keyName, wainsCoatColors, onHandle }) => {
	let className = "";
	const { const_var, params } = useSelector((state) => state.reducer);
	const { standard: standardColors, premium: premiumColors } = useColorPicker(wainsCoatColors, const_var.selSidingOption || "", MATCH_KEY);
	const isColorActive = (color) => {
		return color.image_name ? params.p_w_c_c_id == color.id && color.image_name.split(".")[0].includes(params.wainscotTexture) : params.p_w_c_c_id == color.id && params.p_w_c_c == color.hex_value.replace("#", "0x");
	};
	return (
		<>
			<Accordion.Collapse className="card-collapse-menu" eventKey={keyName}>
				<Card.Body className="card-body-menu">
					{standardColors.length > 0 && <ColorGroup colors={standardColors} onColorSelect={onHandle} isColorActive={isColorActive} isPremium={false} title="Standard Colors" wainsCoatComponent={true} />}
					{premiumColors.length > 0 && <ColorGroup colors={premiumColors} onColorSelect={onHandle} isColorActive={isColorActive} isPremium={true} title="Premium Colors" wainsCoatComponent={true} />}
				</Card.Body>
			</Accordion.Collapse>
		</>
	);
};
